import {
    CloseDetail,
    CloseList,
    Dashboard, Facility, OpenDetail,
    OpenList, Page404
} from '@pages/index';
import React from 'react';


interface RouterProps {
    path: string | undefined;
    element: JSX.Element;
}

const contents: RouterProps[] = [
    { path: '/', element: <Dashboard /> },
    { path: '/open/', element: <OpenList /> },
    { path: '/open/detail/:id', element: <OpenDetail /> },
    { path: '/close/', element: <CloseList /> },
    { path: '/close/detail/:id', element: <CloseDetail /> },
    { path: '/facility/:id', element: <Facility /> },
    { path : '*', element : <Page404 /> },
];

const Routing = {
    base: [],
    content: contents,
    secure: [],
};

export default Routing;